import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // Necessário pro cookie httpOnly do refresh token (setado pela API no login)
  // ir e voltar nas chamadas — sem isso, POST /auth/refresh nunca acha a sessão.
  withCredentials: true,
});

export default api;
